var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container",style:({ height: _vm.loaderContainerHeight })},[_c('div',{staticClass:"loader",style:({ width: `${_vm.percentage}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }